<template>
  <Modal @close="close">
    <div slot="modal-header">
      {{ $t('general.user_details') }}
    </div>

    <div class="m-auto d-flex flex-column justify-content-center align-items-center">
      <div class="d-flex justify-content-between w-100">
        <label class="text-center w-100 mr-1">
          <span>{{ $t('general.firstname') }}</span>
          <b-input v-model="user.firstname" class="d-block" />
        </label>
        <label class="text-center w-100 ml-1">
          <span>{{ $t('general.lastname') }}</span>
          <b-input v-model="user.lastname" class="d-block" />
        </label>
      </div>
      <label class="text-center w-100">
        <span>{{ $t('general.company') }}</span>
        <b-input v-model="user.company" class="d-block" />
      </label>
      <div class="d-flex justify-content-between w-100">
        <label class="text-center w-100 mr-1">
          <span>{{ $t('general.phone') }}</span>
          <b-input v-model="user.phone" class="d-block" />
        </label>
        <label class="text-center w-100 ml-1">
          <span>{{ $t('general.language') }}</span>
          <el-select
            v-model="user.language"
            v-validate="validations.req"
            :name="$t('general.language')"
            class="d-block"
            :placeholder="$t('placeholder.select_language')"
            @input="onSelectLanguage"
          >
            <el-option value="en" :label="$t('languages.en')" />
            <el-option value="de" :label="$t('languages.de')" />
          </el-select>
        </label>
      </div>
      <hr />
      <div class="d-flex justify-content-between w-100">
        <label class="text-center w-100 mr-1">
          <span>{{ $t('general.zip_code') }}</span>
          <b-input v-model="user.zipCode" class="d-block" />
        </label>
        <label class="text-center w-100 ml-1">
          <span>{{ $t('general.city') }}</span>
          <b-input v-model="user.city" class="d-block" />
        </label>
      </div>
      <div class="d-flex justify-content-between w-100">
        <label class="text-center w-100 mr-1">
          <span>{{ $t('general.street') }}</span>
          <b-input v-model="user.street" class="d-block" />
        </label>
        <label class="text-center w-100 ml-1">
          <span>{{ $t('general.country') }}</span>
          <el-select
            v-model="user.country"
            v-validate="validations.city"
            class="w-100 mr-3 d-block"
            name="country"
            filterable
            @input="() => $forceUpdate()"
          >
            <el-option v-for="country in COUNTRIES" :key="country.code" :label="country.name" :value="country.code" />
          </el-select>
        </label>
      </div>
    </div>
    <div slot="modal-footer">
      <el-button @click="onSave">
        {{ $t('general.update') }}
      </el-button>
    </div>
  </Modal>
</template>

<script>
import Modal from '../atoms/Modal';
import { mapActions } from 'vuex';
import StoreModules from '../../store/store-modules';
import User from '../../api/dto/User';
import validations from '../../js/validator/validations';
import COUNTRIES from '../../config/countries';
export default {
  name: 'EditUserDetailsModal',
  components: { Modal },
  props: {},
  mounted() {
    this.user = new User(this.$parse.User.current(), this);
  },
  destroyed() {},
  data() {
    return {
      validations,
      COUNTRIES,
      user: {},
    };
  },
  computed: {},
  methods: {
    ...mapActions(StoreModules.USER, ['loadCurrentUser']),
    close() {
      this.$emit('close');
    },
    onSelectLanguage() {
      this.$forceUpdate();
    },
    async onSave() {
      await this.user.save();
      await this.loadCurrentUser();
      this.$i18n.locale = this.user.language;
      this.$message.success(this.$t('messages.success_user_update'));
      this.close();
      window.location.reload();
    },
  },
};
</script>

<style scoped></style>
